export const hasPermission = (permission, data = []) => {
  let newArr = data.filter((e) => e);
  return newArr.includes(permission);
};

// Temporary stand-in for a real permission module: is_admin, or User/Roles
// View plus Add/Edit. Each admin screen keeps its own named export so a real
// grant can replace one without touching the others.
const hasTenantAdminProxyAccess = ({ Process = [], is_admin } = {}) => {
  if (is_admin) return true;

  const userRolesPermission = Process.find(
    (item) =>
      item?.menuname?.toLowerCase() === "settings" &&
      item?.modulename?.toLowerCase() === "user/roles",
  )?.permission;

  return Boolean(
    hasPermission("view", userRolesPermission) &&
      (hasPermission("add", userRolesPermission) ||
        hasPermission("edit", userRolesPermission)),
  );
};

export const canManageFeatureToggles = (login) =>
  hasTenantAdminProxyAccess(login);

// Notification event routing — same temporary proxy, its own name for later.
export const canManageNotificationEventRouting = (login) =>
  hasTenantAdminProxyAccess(login);
